module.exports = __webpack_public_path__ + "static/media/Icon-06@2x.6ac58316.png";